import { ca } from '@cian/analytics';

export const trackCopyLinkClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ReferralCpd',
    action: 'Click',
    label: 'CopyLink',
  });
};

export const trackCopySuccessShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ReferralCpd',
    action: 'Show',
    label: 'Success',
  });
};

export const trackCopySuccessError = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ReferralCpd',
    action: 'Show',
    label: 'Error',
  });
};
